import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FlightHitHeader } from './FlightHitHeader';

import styles from './FlightHit.scss';
import { FLightHitContent } from './FlightHitContent';

export function FlightHit(props) {
  const {
    node, texts, orderBy, onBuildUpsellUrl, isLoading,
  } = props;

  const {
    date, departure, destinationAirport, country, duration, numFreeSeats, offers,
  } = node;

  const {
    day,
    monthShortName,
    dayShortName,
  } = date;

  const handleBuildUpsellUrl = useCallback((offer) => {
    return onBuildUpsellUrl(node, offer);
  }, [node, onBuildUpsellUrl]);

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <FlightHitHeader
          date={day}
          month={monthShortName}
          weekday={dayShortName}
          destinationAirport={destinationAirport}
          country={country}
          departure={departure}
          numFreeSeats={numFreeSeats}
          duration={duration}
          dayLabel={texts.day}
          daysLabel={texts.days}
          fewSeatLabel={texts.fewSeat}
          fewSeatsLabel={texts.fewSeats}
          perPersonLabel={texts.pricePerPerson}
          isLoading={isLoading}
        />
        <FLightHitContent
          offers={offers}
          orderBy={orderBy}
          specHotelLabel={texts.specHotel}
          specHotelInfo={texts.chooseDifferentHotels}
          unspecHotelLabel={texts.unspecHotel}
          flightOnlyLabel={texts.flightOnly}
          onBuildUpsellUrl={handleBuildUpsellUrl}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

FlightHit.propTypes = {
  node: PropTypes.shape({
    offers: PropTypes.array,
    date: PropTypes.shape({
      day: PropTypes.string,
      monthShortName: PropTypes.string,
      dayShortName: PropTypes.string,
    }),
    departure: PropTypes.shape({
      caId: PropTypes.any,
      name: PropTypes.string,
    }),
    country: PropTypes.shape({}),
    destinationAirport: PropTypes.string,
    numFreeSeats: PropTypes.number,
    duration: PropTypes.number,
  }),
  texts: PropTypes.object,
  isLoading: PropTypes.bool,
  onBuildUpsellUrl: PropTypes.func,
  orderBy: PropTypes.string,
};
